import { queryOptions } from "@tanstack/react-query";

import { apiFetch } from "../lib/api";
import type {
  CrmAdvisorSignalListResponse,
  CrmProfile,
  CrmRescanResponse,
  CrmSignalApplyResponse,
} from "./types";

export const crmAdvisorSignalsQueryOptions = queryOptions({
  queryKey: ["crm", "advisor-signals"] as const,
  queryFn: () =>
    apiFetch<CrmAdvisorSignalListResponse>("/crm/advisor-signals"),
});

export const crmProfileQueryOptions = (deployment: string) =>
  queryOptions({
    queryKey: ["crm", "profile", deployment] as const,
    queryFn: () =>
      apiFetch<CrmProfile>(
        `/crm/profiles/${encodeURIComponent(deployment)}`,
      ),
  });

export function applyCrmAdvisorSignal(
  signalId: string,
): Promise<CrmSignalApplyResponse> {
  return apiFetch<CrmSignalApplyResponse>(
    `/crm/advisor-signals/${encodeURIComponent(signalId)}/apply`,
    { method: "POST" },
  );
}

export function triggerCrmRescan(
  deployment: string,
): Promise<CrmRescanResponse> {
  return apiFetch<CrmRescanResponse>(
    `/crm/profiles/${encodeURIComponent(deployment)}/rescan`,
    { method: "POST" },
  );
}
